module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-medium-97d41332.woff2";